module.exports = __webpack_public_path__ + "static/media/logo.6955e036.png";